export default __webpack_public_path__ + "beta-maps-example-point-annotation-thumbnail-960-c2a7a5e8f45e0c6d26f5e9374c24f784.png";